// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "2026-11-05-04-55d8b33487e95ab8d67fda3030c7b86dd68f2d99/scripts/" + chunkId + ".js";
};